import RenderCmsBlock from '@features/cms/components/RenderCmsBlock';
import type { ICmsContent } from '@features/cms/typescript';
import styles from '@features/productPreview/sections/FrontConfigurator/FrontConfigurator.styles';
import { FreeMode, Mousewheel, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
type PropsType = {
  blocks: ICmsContent[];
};
const ProductCardDocument = ({
  blocks
}: PropsType) => {
  return <div sx={styles.productCardDocumentContainer}>
      <Swiper direction="vertical" modules={[Scrollbar, Mousewheel, FreeMode]} scrollbar={{
      draggable: true
    }} followFinger slidesPerView="auto" freeMode mousewheel allowTouchMove>
        {blocks.map((block, index) => <SwiperSlide key={block.code || index}>
            <RenderCmsBlock block={block} />
          </SwiperSlide>)}
      </Swiper>
    </div>;
};
export default ProductCardDocument;